import getStandardMaterial, { BackAcabadosInfo } from '@utils/conversion/getStandardMaterial'

export function getZocaloMaterialFieldsFromOption(
  option: BackAcabadosInfo | Record<string, unknown>,
  complemento?: string,
) {
  const standard = getStandardMaterial(option as BackAcabadosInfo, 'Basico', 'Zocalo')

  return {
    name: standard.name,
    acabado: standard.acabado,
    url: standard.url,
    groupID: standard.groupID,
    searchID: standard.searchID,
    id: standard.id,
    description: standard.description,
    img: standard.img,
    modelo: 'Zocalo',
    roughness: standard.roughness ?? 1,
    metalness: standard.metalness ?? 0,
    envMapIntensity: standard.envMapIntensity ?? 0,
    opacity: standard.opacity ?? 1,
    color: standard.color ?? '#FFFFFF',
    mirror: standard.mirror,
    repeatX: standard.repeatX ?? 1,
    repeatY: standard.repeatY ?? 1,
    bumpMap: standard.bumpMap,
    bumpScale: standard.bumpScale,
    displacement: standard.displacement ?? 0,
    displacementScale: standard.displacementScale,
    textureRotation: standard.textureRotation ?? 0,
    complemento: complemento ?? standard.complemento,
  }
}